import React from "react";
import classNames from "classnames";
import { websiteBuilderGenerateLinkDesignStyles, IWebsiteBuilderLink } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderLink";

interface IWebsiteBuilderLinkViewProps {
  node: IWebsiteBuilderLink;
}

export function WebsiteBuilderLinkView(props: IWebsiteBuilderLinkViewProps) {
  const { node } = props;

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateLinkDesignStyles(settings);

  return (
    <a
      className={classNames(designStyles.className, "editor-link")}
      style={designStyles.styleProperties}
    >
      {settings.label}
    </a>
  );
}
